import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearFilter,
  filterInitialState
} from "../../features/filter/filterSlice";

const ResetFilter = () => {
  const dispatch = useDispatch();
  const filter = useSelector((state) => state.filter || {});
  const [activeFilter, setActiveFilter] = useState(false);

  const handleReset = () => dispatch(clearFilter());
  // Set filter reset active state
  useEffect(
    () =>
      setActiveFilter(
        Object.entries(filter).toString() ===
          Object.entries(filterInitialState).toString()
      ),
    [filter]
  );

  return (
    <button
      onClick={handleReset}
      className="bg-red-200 disabled:bg-gray-200 text-red-600 disabled:text-gray-600 px-4 py-2 rounded font-medium whitespace-nowrap h-fit"
      disabled={activeFilter}
    >
      Reset Filter
    </button>
  );
};

export default ResetFilter;
